<template>
  <div>
    <el-row class="condition">
      <el-col :span="4">
        <el-page-header @back="goBack" :content="contentName" v-if="idcId">
        </el-page-header>
      </el-col>
      <el-col :span="10">
        <div v-if="!idcId">
          <el-button style="margin-left: 10px;" v-if="btnInList('instanceList_add')" type="primary" size="small"
            @click="add" icon="el-icon-plus">新增
          </el-button>
        </div>
        <div v-else v-html="'\u00a0'"></div>
      </el-col>
<!--      <el-col :span="2">-->
<!--        <div v-if="!isRed">-->
<!--          <img src="@/assets/warn.png" style="width: 40px;height: 40px;margin-left: -400px" />-->
<!--        </div>-->
<!--        <div v-else>-->
<!--          <img v-on:click="clockSearch" src="@/assets/warn1.png" style="width: 40px;height: 40px;margin-left: -400px" />-->
<!--          <div style="margin-top:-30px;margin-left: -350px;color: red">受影响的实例有 {{ num }} 个</div>-->
<!--        </div>-->
<!--      </el-col>-->
<!--      <el-col :span="1">-->
<!--        <span >-->
<!--          <el-button type="danger" icon="el-icon-s-opportunity" circle size="mini" @click="jumpProxy()"></el-button>-->
<!--        </span>-->
<!--      </el-col>-->
      <el-col :span="7" style="float: right;">
        <el-input v-model="search" placeholder="搜索" @change="getDatas">
          <el-select v-model="condition" slot="prepend" placeholder="请选择">
            <el-option v-for="(option, index) in conditionList" :key="index" :value="option.type"
              :label="option.value"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="getDatas"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <div>
      <list-item :item="listHeader" :showOperate="false" style="font-weight: bold;color: #909399;line-height:1;" />
    </div>
    <div class="el-table__empty-block noneData" v-if="tables.length == 0">
      <span class="el-table__empty-text">暂无数据</span>
    </div>
    <div v-for="(item, idx) in tables" :key="item.id" v-else :id="'instance' + item.id">
      <box-progress :persents="item.progs" :height="76" :insId="item.id">
        <list-item :item="item" :index="idx" :currentPage="currentPage" :docker="isDocker" :onlineInstanceId="onlineId"
          style="height:66px;" @itemCallback="itemCallback" />
      </box-progress>
    </div>
    <el-pagination class="fy" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" :total="totalElement"
      layout="total, sizes, prev, pager, next, jumper"></el-pagination>

  </div>
</template>

<script>
import { Loading, Progress } from "element-ui";
import BoxProgress from "../common/BoxProgress.vue";
import ListItem from "./InstanceListItem.vue";
import { mapState, mapMutations } from 'vuex';

export default {
  name: "InstanceList",
  components: { BoxProgress, ListItem },
  data() {
    return {
      showEdit: false, //新增窗口
      search: null, //搜索关键字
      isRed: false,//倒计时颜色显示
      wsId: "",
      num: '',
      searchId: null,
      currentPage: 1,
      isDocker: "",
      onlineId: "",
      pageSize: 10,
      totalElement: 0,
      tables: [],
      // 字段名，用作表头
      listHeader: {
        onlineId: "",
        isDocker: "",
        id: "ID",
        deviceName: "设备名称",
        moduleType: "模块类型",
        moduleVersion: "模块版本",
        operate: "操作",
        statusDesc: "状态描述",
        status: {
          description: '结果描述'
        },
        alias: '别名',
        name: '服务名称',
        integrationVersionAlias: '所属集成',
      },
      condition: null,
      idcId: null,//idc机房Id
      contentName: "",
      bsType: "",
      conditionList: [
        {
          type: null,
          value: '全部'
        }, {
          type: 'alias',
          value: '实例别名'
        }, {
          type: 'integration_version_alias',
          value: '集成名称'
        }, {
          type: 'integration_version_version',
          value: '集成版本'
        }, {
          type: 'module_type',
          value: '模块类型'
        }, {
          type: 'id',
          value: '实例id'
        }, {
          type: 'device_id',
          value: '设备id'
        }], //条件列表
      relationProxyList: [],
    }
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否可以显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn.some(childOp => childOp.name.includes(childName))
        }
      }
    },
  },
  created() {
    // this.refresh();
    this.getListOperations('instancelist');
    if (!this.currentMenu) {
      return
    }
    const params = this.$route.params;
    if (params && params.currentPage) {
      this.currentPage = params.currentPage
    }
    if (params && params.idcId) {
      this.idcId = params.idcId
    }
    if (params && params.bsType) {
      this.bsType = params.bsType;
      if (this.bsType == "device") {
        this.contentName = "设备管理"
      } else {
        this.contentName = "proxy管理"
      }
    }
    if (params && params.serviceAgentId) {
      this.condition = 'id';
      this.search = params.serviceAgentId;
      this.resetPage()
    } else if (params.type == 'arrange' && params.id) {
      // 如果是查看编排下的实例列表，使用精确查询
      this.condition = 'layout';
      this.search = params.id;
      this.resetPage()
    } else {
      this.getDatas();
    }
    // this.getDatas();
    this.initWebSocket()
  },
  watch: {
    search: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.search = null
        }
        this.currentPage = 1;
        this.pageSize = 10;
      }
    }
  },

  methods: {
    ...mapMutations(['updateWebsocket', 'getListOperations']),
    jumpProxy() {
      this.$router.push({
        path: 'butelproxylist',
        name: 'butelproxylist',
        params: {
          idcId: 0,
          flag: 2
        }
      });
    },
    // refresh() {
    //   //计时器正在进行，退出函数
    //   if (this.intervalId != null) {
    //     return;
    //   }
    //   // 计时器为空，操作
    //   this.intervalId = setInterval(() => {
    //     this.initPage(); //加载数据函数
    //   }, 300000);
    // },
    // initPage() {
    //   this.$axios.get(this.baseUrl3 + 'management3/instance/poll')
    //     .then(({data: {data, msg, code}}) => {
    //       if (code == 20000) {
    //         if (data) {
    //           this.isRed = true;
    //           this.searchId = data;
    //           this.num = data.split(",").length
    //         } else {
    //           this.isRed = false;
    //         }
    //       } else {
    //         this.$message.error('操作失败：' + msg)
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    // },
    itemCallback() {
      //this.search = null;
      this.condition = null;
      this.getDatas()
    },
    goBack() {
      if (this.bsType == "proxy") {
        this.$router.push({
          path: 'butelproxylist',
          name: 'butelproxylist',
          params: {
            idcId: this.idcId,
            flag: 1
          }
        });
      } else {
        this.$router.push({
          path: 'idcdevicelist',
          name: 'idcdevicelist',
          params: {
            idcId: this.idcId
          }
        });
      }
    },
    add() {
      // this.$router.push("instance");
      this.$router.push({
        path: "instancecreate",
        query: {
          p: "list"
        }
      });
    },
    resetPage() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.getDatas()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // this.getDatas()
      this.getDatas()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.getDatas()
      this.getDatas()
    },
    editCallback() {
      this.showEdit = false;
    },
    clockSearch() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.tables = [];
      let model = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      let url = this.baseUrl
        + "instance/findPageByCondition/"
        + model.page + '/'
        + model.pageSize + '/'
        + 'instanceId' + '/'
        + this.searchId;
      this.$axios
        .get(url)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.condition = 'id';
            this.search = this.searchId;
            this.totalElement = data.total;
            const list = data.list ? data.list : [];
            list.forEach((obj, index) => {
              let item = {
                status: {},
                progs: []
              };
              if (obj.service) {
                item = {
                  name: obj.service.name,
                  status: {
                    operation: {}
                  },
                  progs: []
                };
                item.status = Object.assign({}, item.status, obj.service.status);
                if (item.status.value == 0) {
                  if (item.status.progress == 9 || item.status.progress == 0 || item.status.progress == 1 || item.status.progress == 2) {
                    item.progs = [{ percent: item.status.percent, progress: item.status.progress }]
                  }
                }
              }
              this.tables.push(Object.assign(item, obj));
            });
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        })
        .catch(error => {
          loading.close();
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    // searchDatas() {
    //   if (!this.condition) {
    //     this.getDatas();
    //     return
    //   }
    //   let loading = Loading.service({
    //     fullscreen: true,
    //     text: "数据加载中..."
    //   });
    //   this.tables = [];
    //   let model = {
    //     pageNo: this.currentPage,
    //     pageSize: this.pageSize
    //   };
    //   let url = this.baseUrl
    //     + "instance/findPageByCondition/"
    //     + model.page + '/'
    //     + model.pageSize + '/'
    //     + this.condition + '/'
    //     + this.search;
    //   this.$axios
    //     .get(url)
    //     .then(({data: {msg, data, code}}) => {
    //       if (code == 20000) {
    //         this.relationProxyList = JSON.parse(localStorage.getItem("relationProxyList"));
    //         this.totalElement = data.total;
    //         const list = data.list ? data.list : [];
    //         let arr=[];
    //         list.forEach((obj, index) => {
    //           arr.push(obj.id);
    //           let item = {
    //             status: {},
    //             progs: []
    //           };
    //           if (obj.service) {
    //             item = {
    //               name: obj.service.name,
    //               status: {
    //                 operation: {}
    //               },
    //               progs: []
    //             };
    //             item.status = Object.assign({}, item.status, obj.service.status);
    //             if (item.status.value == 0) {
    //               if (item.status.progress == 9 || item.status.progress == 0 || item.status.progress == 1 || item.status.progress == 2) {
    //                 item.progs = [{percent: item.status.percent, progress: item.status.progress}]
    //               }
    //             }
    //           }
    //           this.tables.push(Object.assign(item, obj));
    //         });
    //         this.wsId=arr.join(',');
    //         // this.websocketsend(this.wsId);
    //         this.websocket.ws.send(this.wsId);
    //         // if(this.condition=="instanceId"){
    //         //   this.websocket.ws.send(this.search);
    //         // }
    //       } else {
    //         this.$message({showClose: true, message: msg, type: "error"});
    //         console.log(msg);
    //       }
    //       loading.close();
    //     })
    //     .catch(error => {
    //       loading.close();
    //       this.$message({
    //         showClose: true,
    //         message: "系统异常",
    //         type: "error"
    //       });
    //       console.log(error);
    //     });
    // },
    getDatas() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.tables = [];

      let model = {}
      if (this.condition == null || this.search == null) {
        model = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          condition: this.search
        };
      } else {
        let obj = {}
        obj[this.condition] = this.search;
        model = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          keyword: obj
        };
      }


      // let url = this.baseUrl
      //   + "instance/findByPageLike/" + model.page + '/' + model.pageSize + '/' + this.search;
      let url = this.baseUrl3 + "instance/list/page"
      let _this = this;
      this.$axios.post(url, model).then(({ data: { msg, data, code } }) => {
        if (code == 20000) {
          this.relationProxyList = JSON.parse(localStorage.getItem("relationProxyList"));
          this.isDocker = data.docker;
          this.totalElement = data.total;
          const list = data.list ? data.list : [];
          let arr = [];
          list.forEach((obj, index) => {
            arr.push(obj.id);
            let item = {
              status: {},
              progs: []
            };
            if (obj.service) {
              item = {
                name: obj.service.name,
                // status: {
                //   code: obj.service.status.code,
                //   description: obj.service.status.description,
                //   id: obj.service.status.id,
                //   percent: obj.service.status.percent, // 进度
                //   progress: obj.service.status.progress, //当前进度条类型0:send, 1:clone, 2:install....
                //   value: obj.service.status.value, //0.正在进行 1.成功 2.失败
                // },
                // status: obj.service.status ? obj.service.status : {},
                status: {
                  operation: {}
                },
                progs: []
              };
              item.status = Object.assign({}, item.status, obj.service.status);
              if (item.status.value == 0) {
                if (item.status.progress == 9 || item.status.progress == 0 || item.status.progress == 1 || item.status.progress == 2) {
                  item.progs = [{ percent: item.status.percent, progress: item.status.progress }]
                }
              }
            }
            _this.tables.push(Object.assign(item, obj));
          });
          // this.wsId = arr.join(',');
          this.websocket.subIds = arr
          this.websocketsend();
          // this.websocket.ws.send(this.wsId);

        } else {
          this.$message({ showClose: true, message: msg, type: "error" });
          console.log(msg);
        }
        loading.close();
      })
        .catch(error => {
          loading.close();
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    /**
     * 连接websocket
     */
    localSocket() {
      let that = this;
      let url = "";
      let wsuri = "";
      if (that.baseUrl3.indexOf('https://') != -1) {
        url = that.baseUrl3.split('https://')[1];
        wsuri = "wss://" + url + "instance";
      } else {
        url = that.baseUrl3.split('http://')[1];
        //初始化weosocket
        wsuri = "ws://" + url + "instance";
      }

      if ('WebSocket' in window) {
        console.log('您的浏览器支持 WebSocket!');
        that.ws = new WebSocket(wsuri);
        that.websocket.setWs(that.ws);
        that.ws.onopen = function () {
          that.websocket.connectState = true;
          console.log('连接成功');
          that.count = 0;
          that.ws.onmessage = that.websocketonmessage
          that.websocketsend(that.wsId);
        };
        //that.onopen(); 这个地方未定义是会报错，所以我写成了  that.ws.onopen = function() {console.log('开始连接')};
        that.ws.onclose = function (event) {
          console.log('WebSocket connection closed with close code: ' + event.code + ',reason: ' + event.reason);
          // 关闭 websocket
          that.websocket.connectState = false;
          console.log('连接已关闭,尝试重连...');
          that.ws.close();
          that.reconnect(); // 尝试重连
        };
        that.ws.onerror = function (event) {
          console.log('WebSocket error observed:', event);
          // 处理错误后可以选择重连
          that.websocket.connectState = false;

        }
      } else {
        // 浏览器不支持 WebSocket
        console.log('您的浏览器不支持 WebSocket!')
        this.isWs = false;
      }
    },
    reconnect() {
      if (!this.websocket.connectState) {
        let _this = this;
        let i = _this.count % _this.websocket.reconnectTimes.length; // 使用数组长度
        let t = 1000 * _this.websocket.reconnectTimes[i]; // 获取当前重连间隔
        console.log(new Date() + "第" + _this.count + "次重连,间隔时间" + _this.websocket.reconnectTimes[i] + "秒");
        _this.count++;
        setTimeout(() => {
          _this.localSocket(); // 在指定时间后尝试重连
        }, t);
      }
    },
    initWebSocket() {
      //const url = this.baseUrl.split('http://')[1]
      //初始化weosocket
      //const wsuri = "ws://" + url + "instance";

      // let url = "";
      // let wsuri = "";
      // if (this.baseUrl3.indexOf('https://') != -1) {
      //   url = this.baseUrl3.split('https://')[1];
      //   wsuri = "wss://" + url + "instance";
      // } else {
      //   url = this.baseUrl3.split('http://')[1];
      //   //初始化weosocket
      //   wsuri = "ws://" + url + "instance";
      // }
      // this.websock = new WebSocket(wsuri);
      // this.websock.onmessage = this.websocketonmessage;
      // // this.websock.send = this.websocketsend;
      // this.websock.onopen = this.websocketonopen;
      // this.websock.onerror = this.websocketonerror;
      // this.websock.onclose = this.websocketclose;

      // this.websocket.ws.onmessage = this.websocketonmessage;
      // this.websocket.ws.onopen = this.websocketonopen;
      // this.websocket.ws.onerror = this.websocketonerror;
      // this.websocket.ws.onclose = this.websocketclose;
      if (!this.websocket.connectState) {
        this.localSocket()
      } else {
        this.websocket.ws.onmessage = this.websocketonmessage
      }
    },
    // websocketonopen() {
    //   //连接建立之后执行send方法发送数据
    //   console.log("open");
    //   this.connectState = true;
    //   if(this.wsId){
    //     this.websocketsend(this.wsId)
    //   }
    // },
    // websocketonerror() {
    //   //连接建立失败重连
    //   // webSocket 断开连接 连接状态 重置
    //   this.connectState = false;
    //   // 大于9 次, 不再重连
    //   if (this.reconnectTimes <= 9) {
    //     console.log("ws断开连接...第"+this.reconnectTimes+"次重连")
    //     this.reconnect();
    //   }
    // },
    websocketonmessage(e) {
      console.log("接收数据")
      //数据接收
      if (e) {
        // 获取到的对象不为空
        if (e.data != null && Object.keys(e.data).length != 0) {
          let data = JSON.parse(e.data);
          //console.log('instance-websocket-message:')
          //console.log(data)
          this.updateWebsocket(data);
          const _this = this;
          // let tr
          for (let i = 0; i < _this.tables.length; i++) {
            // tr = _this.tables[i]
            if (_this.tables[i].id == data.insId) {
              if (_this.tables[i].status.time) {
                if (_this.tables[i].status.time > data.time) {
                  return
                }
              }

              const progress = data.progress;
              const value = data.value;
              const percent = data.percent;

              let item = {
                status: data,
                name: data.name, //推送的服务名称
              };
              // 建立依赖成功后，改变editDep为true
              if (progress == 8 && value == 1) {
                _this.tables[i].editDep = true
              }

              // 进度条渲染条件：1.配置过程中
              if (progress == 9) {
                item.progs = [{ percent: percent, progress: progress }]
              }
              // 进度条渲染条件：2.安装过程
              if (progress == 2 || progress == 0 || progress == 1 || progress == 3
                || progress == 4 || progress == 11) {
                if (_this.tables[i].progs.length == 0) {
                  item.progs = [{ percent: percent, progress: progress }]
                } else {
                  item.progs = _this.tables[i].progs;
                  let progressExist = false;
                  for (let j = 0; j < item.progs.length; j++) {
                    if (item.progs[j].progress == progress) {
                      progressExist = true;
                      item.progs[j].percent = percent;
                      break
                    }
                  }
                  if (!progressExist) {
                    item.progs.push({
                      percent: percent,
                      progress: progress
                    })
                  }
                }
              }
              // 实例下载过程
              if (progress == 19) {
                item.progs = [{ percent: percent, progress: progress }]
              }
              _this.$set(_this.tables, i, Object.assign({}, _this.tables[i], item));
              if (progress == 4 || progress == 5) {
              }
              break
            }
          }
        }
      }
    },
    websocketsend() {
      // console.log(this.websocket)
      if (this.websocket.connectState) {
        this.websocket.ws.send(this.websocket.getSub());
      } else {
        this.$message.error("ws连接意外断开，请稍后再试")
      }
    }
    // websocketclose(e) {
    //   //关闭
    //   console.log("断开连接", e);
    //   this.connectState = false;
    //   // 大于9 次, 不再重连
    //   // if (this.reconnectTimes <= 9) {
    //   //   this.reconnect();
    //   // }
    // },
    // /**
    //  * 断线重连
    //  */
    // reconnect() {
    //   // 连接断开时, 进行重连
    //   if (!this.connectState) {
    //     // 连接次数
    //     let i = this.reconnectTimes;
    //     let _this = this;
    //     // 清除之前的定时器
    //     if (_this.timeOutNum != null) {
    //       clearTimeout(_this.timeOutNum); //去掉定时器
    //     }
    //     // 1,2,3 前三次 1秒重连一次
    //     if (i <= 3) {
    //       _this.timeOutNum = setTimeout(() => {
    //         _this.initWebSocket();
    //       }, 1000);
    //     } else if (i <= 6 && i > 3) {
    //       // 4,5,6 等待30s 30s重连一次
    //       _this.timeOutNum = setTimeout(() => {
    //         _this.initWebSocket();
    //       }, 30000);
    //     } else if (i > 6) {
    //       // 7,8,9 等待60s 60s重连一次
    //       _this.timeOutNum = setTimeout(() => {
    //         _this.initWebSocket();
    //       }, 60000);
    //     }
    //     // 连接次数 +1
    //     this.reconnectTimes = ++this.reconnectTimes;
    //   }
    // }
  }
};
</script>
<style scoped>
.fy {
  text-align: center;
  margin-top: 30px;
}

.noneData {
  text-align: center;
  border-top: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  font-size: 14px;
}

.condition>>>.el-select .el-input {
  width: 130px;
}

.condition>>>.el-input-group__append,
.condition>>>.el-input-group__prepend {
  background-color: #fff !important;
}
</style>
